// removed by extract-text-webpack-plugin
module.exports = {"table":"_3Zgy5G9nRPrchpgn6v9v-2","heading":"_1WTS4s9owQQitNfNX7X3ko","body":"_3tertPWKv6VvC_apoj3077","loading":"_3Wz3bW8zNfqZKSNBaBEHCA","empty":"_34RI2_gXWzZJgkZOw-IsOq","ActivityTable":"_2E4iDbTjA0z4Qp8sUVqcR8","ActivityTableItem--danger":"_1T-_TNoc2hsi03ef4bB1Rj"};


//////////////////
// WEBPACK FOOTER
// ./components/ActivityTable.module.css
// module id = 2336
// module chunks = 1